// libraries
import { Card } from 'react-bootstrap';
import { useCurrentOrchestrator } from '@domains/orchestrator-pricing-committee/hooks/useCurrentOrchestrator';

// components
import { StatusDates } from '../../../shared/StatusDates';
import { StatusCircle } from '@domains/orchestrator-pricing-committee/components/shared/StatusCircle';
import { WrapperOrchestrator } from '@domains/orchestrator-pricing-committee/components/shared/styles';
import { OrchestratorTrackerLine } from '../OrchestratorTrackerLine/OrchestratorTrackerLine';
import { WorkflowIdInfo } from './components/WorkflowIdInfo';
import { RefreshOrchestratorButton } from './components/RefreshOrchestratorButton';

export const OrchestratorGeneralInfo = () => {
  const { currentOrchestrator, rawNid } = useCurrentOrchestrator();

  const { data } = currentOrchestrator;
  const status = data?.status ?? 'No status';
  const workflowId = data?.workflow_id;
  const startAt = data?.start_at;
  const endAt = data?.end_at;
  const updatedAt = data?.updated_at;

  return (
    <WrapperOrchestrator style={{ height: '100%' }}>
      <Card className="mb-4 h-100 d-flex flex-column">
        <div style={{ flex: '0 0 auto' }} className="pb-2">
          <div className="d-flex gap-4 align-items-center p-3">
            <Card.Title className="d-flex gap-2 align-items-center mb-0 pb-0">
              <StatusCircle status={status} />
              <span className="fw-bold nid">{rawNid || 'Nid'}</span>
              {rawNid && <RefreshOrchestratorButton />}
            </Card.Title>
            <WorkflowIdInfo workflowId={workflowId} />
          </div>
          <div className="px-3">
            <StatusDates
              status={status}
              startAt={startAt}
              endAt={endAt}
              updatedAt={updatedAt}
            />
          </div>
        </div>
        <Card.Body
          className="p-3"
          style={{
            flex: '1 1 auto',
            overflowY: 'auto',
            minHeight: 0,
          }}
        >
          <OrchestratorTrackerLine />
        </Card.Body>
      </Card>
    </WrapperOrchestrator>
  );
};
